import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ContratoDetailDto } from '@models/contrato/contratoDetailDto.model';
import { isFalsy } from 'utility-types';

/**
 * Detalle de un contrato en formato tarjeta.
 *
 * Sirve embebido (@Input) y como contenido de un diálogo (MAT_DIALOG_DATA).
 */
@Component({
  selector: 'app-card-contrato',
  templateUrl: './card-contrato.component.html',
  styleUrls: ['./card-contrato.component.css']
})
export class CardContratoComponent implements OnInit {

  @Input() contratoDetailDto!: ContratoDetailDto;

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: ContratoDetailDto
  ) { }

  ngOnInit(): void {
    // El dato del diálogo manda; si no vino ninguno, se evita el null en la vista.
    if (!isFalsy(this.data))
      this.contratoDetailDto = this.data;

    if (isFalsy(this.contratoDetailDto))
      this.contratoDetailDto = new ContratoDetailDto();
  }

  /**
   * Ubicación armada con ubicacion + piso + departamento.
   * El DTO no trae una descripción ya formada.
   */
  ubicacionPropiedad(): string {
    const propiedad: any = this.contratoDetailDto?.propiedad;

    if (isFalsy(propiedad))
      return "";

    return [
      propiedad.ubicacion,
      propiedad.piso ? `Piso ${propiedad.piso}` : null,
      propiedad.departamento ? `Depto ${propiedad.departamento}` : null
    ].filter(p => !isFalsy(p)).join(' ');
  }

  /** Color del chip según el estado, para que se lea sin tener que leerlo. */
  claseEstado(): string {
    const estado = (this.contratoDetailDto?.estadoContrato?.descripcion || "").toLowerCase();

    if (estado.includes('activo')) return 'estado-activo';
    if (estado.includes('rescindido')) return 'estado-rescindido';
    if (estado.includes('finalizado')) return 'estado-finalizado';

    return 'estado-neutro';
  }

  /**
   * Porcentaje del contrato ya transcurrido. Null si faltan fechas.
   * Se topea en 100 para que la barra no se desborde en contratos vencidos.
   */
  porcentajeTranscurrido(): number | null {
    const inicio = this.aFecha(this.contratoDetailDto?.fechaComienzo);
    const fin = this.aFecha(this.contratoDetailDto?.fechaVencimiento);

    if (inicio == null || fin == null || fin <= inicio)
      return null;

    const total = fin.getTime() - inicio.getTime();
    const corrido = new Date().getTime() - inicio.getTime();

    return Math.min(100, Math.max(0, Math.round((corrido / total) * 100)));
  }

  /** Días hasta el vencimiento. Negativo o cero significa vencido. */
  diasRestantes(): number | null {
    const fin = this.aFecha(this.contratoDetailDto?.fechaVencimiento);

    if (fin == null)
      return null;

    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);

    return Math.round((fin.getTime() - hoy.getTime()) / 86400000);
  }

  private aFecha(valor: any): Date | null {
    if (isFalsy(valor))
      return null;

    const fecha = new Date(valor);

    return isNaN(fecha.getTime()) ? null : fecha;
  }

  isFalsy(valor: any) {
    return isFalsy(valor);
  }

  trackByItems(index: number, item: any): any { return index; }
}
